import * as React from 'react';
import dayjs from 'dayjs';
import { Page, Card } from 'tabler-react';
import { Link } from 'react-router-dom';
import PageComponent from '../PageComponent';
import store from '../../shared/store';
import Request from '../../shared/request';
import './bind.scss';

const DEVICE_MAP = {
  'android-tv': 'Android TV',
  chrome: 'CHROME 扩展',
  ios: 'iOS',
  android: 'Android',
  mac: 'macOS',
  windows: 'Windows',
};
class BindIndex extends PageComponent {
  state = {
    devices: [],
    loading: '',
  };

  componentDidMount() {
    this.getDevices();
  }

  getDevices = async () => {
    const devices = await Request.call('getDevices');
    if (devices) {
      this.setState({ devices });
    }
  };

  unbind = async deviceId => {
    this.setState({ loading: deviceId });
    const devices = await Request.call('unbindDevice', { deviceId });
    if (devices) {
      this.setState({ devices });
    }
    this.setState({ loading: '' });
  };

  goVas = () => {
    this.props.history.push('/dashboard/vas?planId=device_2');
  };

  getLeave = () => {
    if (this.state.devices) {
      const num = store.user.clients - this.getUsed();
      return num > 0 ? num : 0;
    }
    return '-';
  };

  getUsed = () =>
    this.state.devices.some(d => d.app === 'chrome')
      ? this.state.devices.length - 1
      : this.state.devices.length;

  render() {
    return (
      <Page.Content className="page-bind">
        <Card>
          <Card.Header>
            <Link to="/dashboard">
              <i className="fa fa-angle-left" />
              <span>返回</span>
            </Link>
            <Card.Title>当前已绑定设备</Card.Title>
          </Card.Header>
          <div className="content">
            <div className="header">
              <div className="num">
                已绑定设备
                <span className="color">{this.getUsed()}</span> 台，剩余{' '}
                <span>{this.getLeave()}</span> 台
              </div>
              {/* <div className="btn-vas" onClick={this.goVas}>
                新增设备
              </div> */}
            </div>
            <div className="body">
              {this.state.devices
                .filter(d => d.app === 'chrome')
                .map((device, i) => (
                  <div className="item-device">
                    <div className="icon">
                      <i className="fad fa-computer-speaker" />
                    </div>
                    <div className="middle">
                      <div className="name">
                        {DEVICE_MAP[device.app]}:{device.version}
                        {i === 0 ? ' 免费设备' : ''}
                      </div>
                      <div className="time">
                        <span>最后登录时间</span>
                        <span>
                          {dayjs(device.lastUpdateAt).format(
                            'YYYY.MM.DD HH:mm',
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="right">
                      <div
                        className="btn-unbind"
                        onClick={() => this.unbind(device._id)}>
                        {this.state.loading === device._id
                          ? '正在解绑...'
                          : '解除绑定'}
                      </div>
                    </div>
                  </div>
                ))}
              {this.state.devices
                .filter(v => v.app !== 'chrome')
                .map(device => (
                  <div className="item-device">
                    <div className="icon">
                      <i className="fad fa-computer-speaker" />
                    </div>
                    <div className="middle">
                      <div className="name">
                        {DEVICE_MAP[device.app]}:{device.version}
                      </div>
                      <div className="time">
                        <span>最后登录时间</span>
                        <span>
                          {dayjs(device.lastUpdateAt).format(
                            'YYYY.MM.DD HH:mm',
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="right">
                      <div
                        className="btn-unbind"
                        onClick={() => this.unbind(device._id)}>
                        {this.state.loading === device._id
                          ? '正在解绑...'
                          : '解除绑定'}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <div className="footer">
              *如超过设备限制，新设备将无法登录，需要在此页面或客户端账号设置页面解绑其他设备，设备列表中一台
              chrome 设备将不计入限制设备数
            </div>
          </div>
        </Card>
      </Page.Content>
    );
  }
}

export default BindIndex;
